module.exports = __webpack_public_path__ + "img/oriental-town-unknown.665ac6ac.jpg";